export const AuthorizationErrorTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Login</span> into the <span className="font-semibold">Enphase
                        Enlighten Portal</span> at https://enlighten.enphaseenergy.com/.
            </li>
            <li>
                <span className="font-semibold">Locate</span> and <span className="font-semibold">select </span>
                the specific system that is experiencing the error to view its details.
            </li>
            <li>
                Go to the <span className="font-semibold">'Settings' page</span> for that system at
                the site level.
            </li>
            <li>
                <span className="font-semibold">Scroll down</span> to
                the <span className="font-semibold">'Access'</span> section on this page.
            </li>
            <li>
                <span className="font-semibold">Check</span> if the <span className="font-semibold">'PV
                        System Maintainer'</span> field lists the name of the your company. If not, please update
                it accordingly.
            </li>
            <li>
                If the field is not populated or incorrect, <span className="font-semibold">update</span> it
                accordingly to ensure proper access permissions are set for Solar Insure to connect and retrieve
                data. Save any changes made.
            </li>
            <li>
                If you're not ready to provide your personal credentials, note that the 'Solar Insure
                Maintainer Account' will be used temporarily for system monitoring,
            </li>
            <li>
                If the issue persists for 10 days after making a correction to
                the <span className="font-semibold">'PV System Maintainer'</span> field, or if you
                were unable to find this specific issue, please <span className="font-semibold">contact customer
                        support.</span> There may be other permission settings on the Enphase site we are currently
                unaware of.
            </li>
        </ul>
    </div>
